import { UI_LANGUAGE_SHORT_CODE_MAP, UiLanguage } from 'admin-panel/constants';
import { resolveUiLanguage } from 'admin-panel/utils/ui-language';

const resolveFromBrowserLanguage = (
  browserLanguage: string | undefined
): UiLanguage => {
  const normalizedBrowserLanguage = browserLanguage?.toLowerCase() || '';
  const matchingPrefix = (
    Object.keys(UI_LANGUAGE_SHORT_CODE_MAP) as Array<
      keyof typeof UI_LANGUAGE_SHORT_CODE_MAP
    >
  ).find((prefix) => normalizedBrowserLanguage.startsWith(prefix));

  if (matchingPrefix) {
    return UI_LANGUAGE_SHORT_CODE_MAP[matchingPrefix];
  }

  return UiLanguage.EnUs;
};

export const resolvePreviewUiLanguage = (
  languageQueryParam: string | undefined,
  browserLanguage: string | undefined = globalThis.navigator?.language
) => {
  return resolveUiLanguage(
    languageQueryParam,
    resolveFromBrowserLanguage(browserLanguage)
  );
};
